const reportVocabulary = {
	'Rapport': {
		'en': 'Report',
		'da': 'Rapport',
		'sv': 'Rapport'
	},
	'Nøytral takst fra': {
		'en': 'Report from',
		'da': 'Rapport fra',
		'sv': 'Rapport från'
	},
	'Rapport oppsummering': {
		'en': 'Summary',
		'da': 'Resumé',
		'sv': 'Rapportsammanfattning'
	},
	'Skade': {
		'en': 'Damage',
		'da': 'Skade',
		'sv': 'Skada'
	},
	'Takstkostnad': {
		'en': 'Report cost',
		'da': 'Rapport omkostninger',
		'sv': 'Rapport kostnad'
	},
	'Totalt': {
		'en': 'Total ex. vat',
		'da': 'Samlet ex. moms',
		'sv': 'Summa ex. moms'
	},
	'Sum eks. mva': {
		'en': 'Total ex. vat',
		'da': 'Samlet ex. moms',
		'sv': 'Summa ex. moms'
	},
	'Totalpris inkl. mva': {
		'en': 'Total inc. vat',
		'da': 'Samlet inkl. moms',
		'sv': 'Totalpris inkl moms'
	},
	'Mva': {
		'en': 'VAT',
		'da': 'MOMS',
		'sv': 'MOMS'
	},
	'Skadedetaljer': {
		'en': 'Damage details',
		'da': 'Skadedetaljer',
		'sv': 'Skadedetaljer'
	},
	'Total kostnad': {
		'en': 'Total cost',
		'da': 'Udgifter i alt',
		'sv': 'Total kostnad'
	},
	'Servicehistorikk': {
		'en': 'Service history',
		'da': 'Servicehistorik',
		'sv': 'Servicehistorik'
	},
	'Avslå takst': {
		'en': 'Reject report',
		'da': 'Afvis rapport',
		'sv': 'Avvisa rapport'
	},
	'Godta takst': {
		'en': 'Accept report',
		'da': 'Accepter rapport',
		'sv': 'Acceptera rapport'
	},
	'Kontaktinfo': {
		'en': 'Contact information',
		'da': 'Kontaktoplysninger',
		'sv': 'Kontaktinformation'
	},
	'Normal slitasje': {
		'en': 'Normal wear',
		'da': 'Almindelig slid',
		'sv': 'Normalt slitage'
	},
	'Skader': {
		'en': 'Damage',
		'da': 'Skade',
		'sv': 'Skada'
	},
	'Godkjent': {
		'en': 'Approved',
		'da': 'Godkendt',
		'sv': 'Godkänd'
	},
	'Normal slitasje defineres som slitasje som må kunne forventes etter en gitt alder og kjørelengde, mens unormal slitasje er det motsatte.': {
		'en': 'Normal wear is defined as wear that must be expected after a given age and mileage, while abnormal wear is the opposite.',
		'da': 'Normalt slid defineres som slid, der må påregnes efter en given alder og kilometertal, mens unormalt slid er det modsatte.',
		'sv': 'Normalt slitage definieras som slitage som måste förväntas efter en given ålder och körsträcka, medan onormalt slitage är det motsatta.'
	},
	'Forsikrings selskap': {
		'en': 'Insurance company',
		'da': 'Forsikringsselskab',
		'sv': 'Försäkringsbolag'
	},
	'Skadedato': {
		'en': 'Damage date',
		'da': 'Skadens dato',
		'sv': 'Skadedatum'
	},
	'Utleieby': {
		'no': 'Utleieby',
		'en': 'Rental City',
		'da': 'Udlejningsby',
		'sv': 'Uthyrningsstad'
	},
	'repairdays': {
		'en': 'repairdays',
		'da': 'repairdays',
		'sv': 'repairdays'
	},
	'Ukjent': {
		'en': 'Unknown',
		'da': 'Ukendt',
		'sv': 'Okänd'
	}, // Contact Form
	'Kjøretøyet er registrert tidligere': {
		'en': 'The vehicle has been registered previously',
		'da': 'Køretøjet har været indregistreret tidligere',
		'sv': 'Fordonet har varit registrerat tidigare'
	},
	'Det finnes allerede en': {
		'en': 'There is already one',
		'da': 'Der er allerede en',
		'sv': 'Det finns redan en'
	},
	'1. Kontaktinfo': {
		'en': '1. Contact info',
		'da': '1. Kontaktoplysninger',
		'sv': '1. Kontaktinformation'
	},
	'Mottaker': {
		'en': 'Receiver',
		'da': 'Modtager',
		'sv': 'Mottagare'
	},
	'Rapporttype:': {
		'en': 'Report type:',
		'da': 'Rapporttype:',
		'sv': 'Rapporttyp:'
	},
	'Utsjekk': {
		'en': 'Check out',
		'da': 'Tjek ud',
		'sv': 'Checka ut'
	},
	'Innsjekk': {
		'en': 'Check in',
		'da': 'Tjek ind',
		'sv': 'Checka in'
	},
	'Kontaktperson': {
		'en': 'Contact person',
		'da': 'Kontaktperson',
		'sv': 'Kontaktperson'
	},
	'/ Sted / Stasjon': {
		'en': '/ Place / Station',
		'da': '/ Placere / Station',
		'sv': '/ Plats / Station'
	},
	'Mobil': {
		'en': 'Mobile number',
		'da': 'Mobil nummer',
		'sv': 'Mobil'
	},
	'Epost': {
		'en': 'Email',
		'da': 'Epost',
		'sv': 'E-post'
	},
	'Firma': {
		'en': 'Company',
		'da': 'Selskab',
		'sv': 'Företag'
	},
	'Rapportvalg': {
		'en': 'Report Options',
		'da': 'Rapport valg',
		'sv': 'Rapportalternativ'
	},
	'Referanse / Kontaktsnummer': {
		'en': 'Reference / Contact number',
		'da': 'Reference / Kontaktnummer',
		'sv': 'Referens / Kontaktnummer'
	},
	'Taksering uten pris/kostnad': {
		'en': 'Appraisal without price',
		'da': 'Rapport uden pris',
		'sv': 'Rapport utan pris'
	},
	'Inkluder Teknisk Inspeksjon': {
		'en': 'Include Technical Inspection',
		'da': 'Inkluder teknisk inspektion',
		'sv': 'Inkludera teknisk inspektion'
	},
	'Info om bil': {
		'en': 'Car info',
		'da': 'Bil info',
		'sv': 'Bilinformation'
	},
	'Kontrakstnummer': {
		'en': 'Contract number',
		'da': 'Kontrakt nummer',
		'sv': 'Kontraktsnummer'
	},
	'Kilometerstand': {
		'en': 'Mileage',
		'da': 'Kilometertal',
		'sv': 'Miltal'
	},
	'Markedsverdi': {
		'en': 'Market value',
		'da': 'Markedsværdi',
		'sv': 'Marknadspris'
	},
	'Eventuelt avvik': {
		'en': 'Any deviation',
		'da': 'Enhver afvigelse',
		'sv': 'Eventuell avvikelse'
	},
	'Dato': {
		'en': 'Date',
		'da': 'Dato',
		'sv': 'Datum'
	},
	'på dette kjøretøyet': {
		'en': 'on this vehicle',
		'da': 'på dette køretøj',
		'sv': 'på detta fordon'
	},
	'Avbryt': {
		'en': 'Cancel',
		'da': 'Afbestille',
		'sv': 'Annullera'
	},
	'Til Nøkler og ustyr': {
		'en': 'For Keys and equipment',
		'da': 'Til nøgler og udstyr',
		'sv': 'Til nycklar och utrustning'
	},
	// Merknad section
	'Merknad': {
		'en': 'Note',
		'da': 'Bemærk',
		'sv': 'Notera'
	},
	'Initialer/Navn takstmann': {
		'en': 'Initials/Name appraiser',
		'da': 'Initialer/Navnevurderingsmand',
		'sv': 'Initialer/Namnvärderingsman'
	},
	'Rabatt': {
		'en': 'Discount',
		'da': 'Rabat',
		'sv': 'Rabatt'
	},
	'Tilleggskommentar': {
		'en': 'Additional comment',
		'da': 'Yderligere kommentar',
		'sv': 'Övrig kommentar'
	},
	'Antall reparasjonsdager': {
		'en': 'Number of repair days',
		'da': 'Antal reparationsdage',
		'sv': 'Antal reparationsdagar'
	},
	'DBS takst er benyttet': {
		'en': 'DBS rate is used',
		'da': 'Der anvendes DBS-takst',
		'sv': 'DBS taxa används'
	},
	'Reparasjon er gjennomført': {
		'en': 'Repairs have been completed',
		'da': 'Reparationer er afsluttet',
		'sv': 'Reparationer har slutförts'
	},
	'Rediger rapport' : {
		'en': 'Edit report',
		'da': 'Rediger rapport',
		'sv': 'Redigera rapport'
	},
	'Be om skade-takst': {
		'en': 'Ask for damage report',
		'da': 'Spørg efter skaderapport',
		'sv': 'Fråga efter skaderapport'
	},
	'Send rapport til ': {
		'en': 'Send report to ',
		'da': 'Send rapport til ',
		'sv': 'Skicka rapport till '
	},
	'Send eller avslå takst': {
		'en': 'Send or reject rate',
		'da': 'Send eller afvis takst',
		'sv': 'Skicka eller avvisa taxa'
	},
	'Send manuell ': {
		'en': 'Send manually ',
		'da': 'Send manuelt ',
		'sv': 'Skicka manuellt '
	},
	'Send til stasjon': {
		'en': 'Send to station',
		'da': 'Send til stationen',
		'sv': 'Skicka till stationen'
	},
	'Ny utsjekk': {
		'en': 'New check out',
		'da': 'Ny check ud',
		'sv': 'Ny utcheckning'
	},
	'Ny innsjekk': {
		'en': 'New check-in',
		'da': 'Ny check-in',
		'sv': 'Ny incheckning'
	},
	// 1.1 Dekk og felg
	'1.1 Dekk og felg': {
		'en': '1.1 Tires and rims',
		'da': '1.1 Dæk og fælge',
		'sv': '1.1 Däck och fälgar'
	},
	'Dekk og felg': {
		'en': 'Tires and rims',
		'da': 'Dæk og fælge',
		'sv': 'Däck och fälgar'
	},
	'Standard skadebeskrivelse': {
		'en': 'Standard damage description',
		'da': 'Standard skadesbeskrivelse',
		'sv': 'Standard skadebeskrivning'
	},
	'Skadebeskrivelse/Tilstand': {
		'en': 'Damage description/Condition',
		'da': 'Skadebeskrivelse/Tilstand',
		'sv': 'Skadebeskrivning/Skick'
	},
	'Mønsterdybde i millimeter': {
		'en': 'Pattern depth in millimeters',
		'da': 'Mønsterdybde i millimeter',
		'sv': 'Mönsterdjup i millimeter'
	},
	'Skadebeskrivelse/Måleverdi': {
		'en': 'Damage description/Measured value',
		'da': 'Skadebeskrivelse / Målt værdi',
		'sv': 'Skadebeskrivning / Mätvärde'
	},
	'Karosseri/Lakkerte områder': {
		'en': 'Exterior/Painted areas',
		'da': 'Karosseri/Lakerede områder',
		'sv': 'Karosseri/Lackade ytor'
	},
	'Bulk med skade i lakken': {
		'en': 'Dent with damage to the paint',
		'da': 'Bulk med skader på lakken',
		'sv': 'Bulk med skada på lacken'
	},
	'Bulk uten skade i lakken': {
		'en': 'Dent without damage to paintwork',
		'da': 'Bulk uden skader på lakken',
		'sv': 'Bulk utan skador på lacken'
	},
	'Mangelfullt utført tidligere reparasjon': {
		'en': 'Deficient previous repair',
		'da': 'Utilstrækkeligt udført tidligere reparation',
		'sv': 'Otillräckligt utförd tidigare reparation'
	},
	'Ripe som går gjennom lakken': {
		'en': 'Scratch that goes through the paintwork',
		'da': 'Ridse der går gennem lakken',
		'sv': 'Repa som går genom lacken'
	},
	'Ripe som ikke går gjennom lakken': {
		'en': 'Scratch, not through the paintwork',
		'da': 'Ridser der ikke går igennem lakken',
		'sv': 'Repor som inte går igenom lacken'
	},
	'Rust/ lakkblære i lakken': {
		'en': 'Rust/varnish in the paintwork',
		'da': 'Rust/malingblister i malingen',
		'sv': 'Rost/färgblåsa i färgen'
	},
	'Skadet del; reparasjonsmetode, bytte del.': {
		'en': 'Damaged part, repair method, replace part',
		'da': 'Beskadiget del; reparationsmetode, udskift en del.',
		'sv': 'Skadad del; reparationsmetod, byt ut del.'
	},
	'Skadet del; reparasjonsmetode, reparasjon av del.': {
		'en': 'Damaged part, repair method, part repair',
		'da': 'Beskadiget del; reparationsmetode, reparation af del.',
		'sv': 'Skadad del; reparationsmetod, reparation av del.'
	},
	'Skadet/krakelert lykt': {
		'en': 'Damaged/cracked carlight',
		'da': 'Beskadiget/revnet billys',
		'sv': 'Skadad/sprucken lykta'
	},
	'Steinsprut-skader': {
		'en': 'Rubble-injuries',
		'da': 'Skader på stenfald',
		'sv': 'Stensprängningsskador'
	},
	'Steinsprut utover normal slitasje': {
		'en': 'Stone rubble beyond normal wear and tear',
		'da': 'Stenfald ud over normal slitage',
		'sv': 'Stenfall utöver normalt slitage'
	},
	'Glass og lykter': {
		'en': 'Glasses and carlights',
		'da': 'Glas og lys',
		'sv': 'Glas och lyktor'
	},
	'Glass skade': {
		'en': 'Glass damage',
		'da': 'Glasskader',
		'sv': 'Glasskada'
	},
	'Skade/unormal slitasje på glass': {
		'en': 'Damage/abnormal wear on glass',
		'da': 'Skader/unormalt slid på glas',
		'sv': 'Skador/onormalt slitage på glas'
	},
	'Steinsprut skader': {
		'en': 'Rubble damage',
		'da': 'Skader på stenfald',
		'sv': 'Stensprängningsskador'
	},
	'Interiør': {
		'en': 'Interior',
		'da': 'Interiør',
		'sv': 'Interiör'
	},
	'Mangler utstyr som fulgte med bilen som ny': {
		'en': 'Missing equipment that came with the car',
		'da': 'Mangler udstyr der fulgte med bilen som ny',
		'sv': 'Saknar utrustning som följde med bilen som ny'
	},
	'Skadet del som må skiftes': {
		'en': 'Damaged part that needs to be replaced',
		'da': 'Beskadiget del, der skal udskiftes',
		'sv': 'Skadad del som måste bytas ut'
	},
	'Skade/unormal slitasje på interiør': {
		'en': 'Damage/abnormal wear on the interior',
		'da': 'Skader/unormalt slid på indersiden',
		'sv': 'Skador/onormalt slitage på insidan'
	},
	'Utstyr og dokumentasjon': {
		'en': 'Equipment and documentation',
		'da': 'Udstyr og dokumentation',
		'sv': 'Utrustning och dokumentation'
	},
	'Dekk og felger': {
		'en': 'Tires and rims',
		'da': 'Dæk og fælge',
		'sv': 'Däck och fälgar'
	},
	'Skade/unormal slitasje på dekk': {
		'en': 'Damage/abnormal wear on tires',
		'da': 'Skader/unormalt slid på dæk',
		'sv': 'Skador/onormalt slitage på däck'
	},
	'Skade/unormal slitasje på dekk/felg': {
		'en': 'Damage/abnormal wear on the tire/rim',
		'da': 'Skader/unormalt slid på dæk/fælge',
		'sv': 'Skador/onormalt slitage på däck/fälgar'
	},
	'Skade/unormal slitasje på felg': {
		'en': 'Damage/abnormal wear on rim',
		'da': 'Skader/unormalt slid på fælge',
		'sv': 'Skador/onormalt slitage på fälgar'
	},
	'Pris/Verdireduksjon': {
		'en': 'Price/Value reduction',
		'da': 'Pris/Værdi reduktion',
		'sv': 'Pris/Värdeminskning'
	},
	'Beskrivelse av verdireduksjon': {
		'en': 'Description of value reduction',
		'da': 'Beskrivelse af værdireduktion',
		'sv': 'Beskrivning av värdeminskning'
	},
	'Pris': {
		'en': 'Price',
		'da': 'Pris',
		'sv': 'Pris'
	},
	'Input må være et tall': {
		'en': 'Input must be a number',
		'da': 'Input skal være et tal',
		'sv': 'Inmatningen måste vara ett nummer'
	},
	'Legg til ekstra felt': {
		'en': 'Add extra fields',
		'da': 'Tilføj ekstra felter',
		'sv': 'Lägg till extra fält'
	},
	'Ekstra bilde': {
		'en': 'Extra damage',
		'da': 'Ekstra billede',
		'sv': 'Extra bild'
	},
	// 1.2 Takstpunkter
	'1.2 Takstpunkter': {
		'en': '1.2 Rate points',
		'da': '1.2 Takstpunkter',
		'sv': '1.2 Takstpunkter'
	},
	'Takstpunkter': {
		'en': 'Rate points',
		'da': 'Takstpunkter',
		'sv': 'Takstpunkter'
	},
	'Front': {
		'en': 'Front',
		'da': 'Foran',
		'sv': 'Främre'
	},
	'Høyre side': {
		'en': 'Right Side',
		'da': 'Højre side',
		'sv': 'Höger sida'
	},
	'Bakpart': {
		'en': 'Back',
		'da': 'Bakpart',
		'sv': 'Bakpart'
	},
	'Venstre side': {
		'en': 'Left Side',
		'da': 'Venstre side',
		'sv': 'Vänster sida'
	},
	'Kilometerteller': {
		'en': 'Odometer',
		'da': 'Kilometertæller',
		'sv': 'Vägmätare'
	},
	'Tak': {
		'en': 'Roof',
		'da': 'Tag',
		'sv': 'Tak'
	},
	'Drivstoff': {
		'en': 'Fuel',
		'da': 'Brændstof',
		'sv': 'Bränsle'
	},
	'Dokumentasjon': {
		'en': 'Documentation',
		'da': 'Dokumentation',
		'sv': 'Dokumentation'
	}

	// 0 Godkjent
	// 0 Normal slitasje
	// Normal slitasje defineres som slitasje som må kunne forventes etter en gitt alder og kjørelengde, mens unormal slitasje er det motsatte.
}
export default reportVocabulary



// WEBPACK FOOTER //
// ./reports/assets/src/utils/vocabulary.js